import * as React from "react";
import ReactDOM from "react-dom";
import { GeneralContext } from "../../core/general.context";
import { Box } from "../box/box.component";
import { Button } from "../button/button.component";
import { InputElement } from "../input/input.component";
import {StyledLogin, StyledPopupLogin} from "./login.style";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { LabelContext } from "../../core/label.context";
import {BRX_BASE_URL, BRX_LOCALE, IS_GIFT_CARD_ACTIVE} from "../../core/APIUtils";
import { UserContext } from "../../core/user.context";
import { inputMaxLength, nordics } from "../../common/constants";
import {PROJECT_KEY} from "../../core/APIUtils"


type LoginValue = {
  email: string,
  password: string,
}


export const Login = (props: any) => {
  const { className, show, isSideBarLogin, subtitle } = props;
  const { login } = React.useContext(UserContext);
  const { t } = React.useContext(LabelContext);
  const sidebarLogin = isSideBarLogin ? "SidebarLogin" : "";

  let requiredError = t("ecommerce.form-messagge.required")
  let emailError = t("ecommerce.form-messagge.invalid-email")


  const schema = yup.object().shape({
    email: yup.string().email(emailError).required(requiredError),
    password: yup.string().max(inputMaxLength).required(requiredError)
  });

  const { register, handleSubmit, formState: { errors } } = useForm<LoginValue>({
    resolver: yupResolver(schema)
  });

  const onSubmit: SubmitHandler<LoginValue> = data => {
    login(data.email, data.password);
  }

  // controllo al onChange se la password è settata 
  const fieldPassword = register("password", { required: true })
  const origOnChange = fieldPassword.onChange
  fieldPassword.onChange = (e) => {
    const res = origOnChange(e)
    return res
  }

  return (

    <StyledLogin className={`${className}`}>
      <Box className="boxed-mobile secondary unbordered mb-0">
        <div className="centerBlocks">
          <div>
            <p className="text-center login-title">{t("ecommerce.login.doLogin")}</p>
            {subtitle && subtitle !== "" && <p className="text-center" dangerouslySetInnerHTML={{__html: subtitle}}></p>}
            <form onSubmit={handleSubmit(onSubmit)} className="text-center">
              <InputElement label={t("ecommerce.signup.email")} placeholder={t("ecommerce.login.email")}
                            id={`email${sidebarLogin}`} externalRegister={register("email")}
                            errors={errors.email?.message}></InputElement>
              <InputElement className="text-left" type="password" label={t("ecommerce.login.password")}
                            placeholder={t("ecommerce.login.password")} id={`password${sidebarLogin}`}
                            externalRegister={fieldPassword} errors={errors.password?.message}></InputElement>
              <Button className="primary mt-4 mb-2" label={t("ecommerce.login.signIn")} type="submit"
                      value={t("ecommerce.login.signIn")}/>
              <div className="passwordRecovery text-center mb-4">
                <a href={BRX_BASE_URL + '/forgot-password'}>{t("ecommerce.login.forgotPassword")}</a>
              </div>
            </form>
            {show?.includes('register') && (
                <Button redirectPath={BRX_BASE_URL + '/register'} className="primary color--alert"
                        label={t("ecommerce.login.signUp")}></Button>)}
          </div>
        </div>
      </Box>
      {show?.includes('register') && (
        <div className="infoLogin">
          <div className="centerBlocks">
            <span className="infoLoginTitle">{t("ecommerce.infoBox.title")}</span>
            <ul className="infoLoginList">
              {t("ecommerce.infoBox.advantage1") && <li>{t("ecommerce.infoBox.advantage1")}</li>}
              {t("ecommerce.infoBox.advantage2") && <li>{t("ecommerce.infoBox.advantage2")}</li>}
              {t("ecommerce.infoBox.advantage3") && <li>{t("ecommerce.infoBox.advantage3")}</li>}
              {t("ecommerce.infoBox.advantage4") && <li>{t("ecommerce.infoBox.advantage4")}</li>}
              {t("ecommerce.infoBox.advantage5") && <li>{t("ecommerce.infoBox.advantage5")}</li>}
            </ul>
          </div>
        </div>
      )}
    </StyledLogin>
  );
};

export const LoginPopupComponent = () => {
  const { userData } = React.useContext(GeneralContext)
  const container = document.getElementById("reactPlaceholder_loginPopupComponent")

  if (!container)
    return null;
  else {
    const subtitle = container.getAttribute("data-subtitle") || ""
    return ReactDOM.createPortal(
        <>
        {!userData &&
            <LoginPopup openPopupDefault={true} subtitle={subtitle}/>
        }
        </>
        ,container
    )
  }
}

export const LoginFromCooking = (props:any) => {
  const {t} = React.useContext(LabelContext)
  return (
    <StyledPopupLogin>
      <div className={`popup`}>
        <div className="popup-content">
          <button className="close-popup" onClick={props.onClose}>×</button>
          <Login subtitle={t("ecommerce.login.cooking-popup-subtitle")} />
        </div>
      </div>
    </StyledPopupLogin>
  );
}

export const LoginPopup = (props: any) => {
  const { openPopupDefault, subtitle } = props
  const {t} = React.useContext(LabelContext)
  const [isPopupOpen, setIsPopupOpen] = React.useState(openPopupDefault === true);

  const handleLoginClick = () => {
    setIsPopupOpen(true);
    document.body.style.overflow = "hidden";
    const asideCart = document?.querySelector(".checkout-column-aside")
    const preFooter = document?.querySelector(".pre-footer");
    if(asideCart && asideCart instanceof HTMLElement && window.innerWidth > 992){
      asideCart.style.zIndex = "-1"
      // asideCart.style.position = "relative"
    }
    if(preFooter && preFooter instanceof HTMLElement && window.innerWidth > 992){
      // preFooter.style.position = "relative"
      preFooter.style.zIndex = "-1"
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    document.body.style.overflow = "scroll";
    const asideCart = document?.querySelector(".checkout-column-aside")
    const preFooter = document?.querySelector(".pre-footer");
    if(asideCart && asideCart instanceof HTMLElement && window.innerWidth > 992){
      asideCart.style.zIndex = "0"
      // asideCart.style.position = "sticky"
    }
    if(preFooter && preFooter instanceof HTMLElement && window.innerWidth > 992){
      // preFooter.style.position = "relative"
      preFooter.style.zIndex = "0"
    }
  };

  return (
      <div>
        {(!openPopupDefault || openPopupDefault === false) &&
          <div className="login-wrapper pb-5">
            <span>{t("ecommerce.login.popup-title")}</span>
            <button
                className={`btn-checkout`}
                onClick={handleLoginClick}
            >
              {t("ecommerce.login.signIn")}
            </button>
          </div>
        }
        {isPopupOpen && (
            <StyledPopupLogin>
              <div className={`popup ${nordics.includes(PROJECT_KEY) && 'popup-nordics'}`}>
                <div className="popup-content">
                  <button className="close-popup" onClick={handleClosePopup}>×</button>
                  <Login subtitle={subtitle} />
                </div>
              </div>
            </StyledPopupLogin>
        )}

      </div>
  );
};

export const EasyLogin = () => {

  const { userData } = React.useContext(GeneralContext)
  const { logout } = React.useContext(UserContext)
  const container_btn = document.getElementsByClassName("reactPlaceholder_accountLayer_btn");
  const container = document.getElementsByClassName("reactPlaceholder_accountLayer");
  const { t } = React.useContext(LabelContext);

  const loginButton = <button className="ec_btn ec_btn-accountLayer">
    <span className="icon"/>
    <span className="testo">My Account</span>
  </button>;

  const accountPageLink = BRX_BASE_URL + "/my-account";


  let myAccount_welcome = (userData && userData.salutation === "female") ? t("ecommerce.login.welcome-female") : t("ecommerce.login.welcome-male");
  if (userData && userData.salutation === "other") {
    myAccount_welcome = t("ecommerce.login.welcome-male")
  }
  // const myAccount_welcome = (userData.salutation == "female") ? "benvenuta" : "benvenuto";

  const userLoggedLayer = userData &&
    <div className="userLoggedLayer header_layer-container">
      <div className="header_layer-title"> {myAccount_welcome}, <span>{userData.firstName}</span>
        <div>{userData.isEmailVerified ? t("ecommerce.myaccount.email-verified-short-message") : t("ecommerce.myaccount.email-not-verified-short-message")} </div>
      </div>
      <div className="header_layer-body">
        <ul className="userLoggedMenu">
          <li><a href={`${accountPageLink}#personalInfomations`}>{t("ecommerce.myaccount.personal-info-title")} </a></li>
          <li><a href={`${accountPageLink}#my-orders`}>{t("ecommerce.myaccount.orders-title")}</a></li>
          <li><a href={`${accountPageLink}#my-wishlist`}>{t("ecommerce.myaccount.wishlist-title")}</a></li>
          <li><a href={`${accountPageLink}#my-returns`}>{t("ecommerce.myaccount.return-title")}</a></li>
          <li><a href={`${accountPageLink}#my-products`}>{t("ecommerce.myaccount.my-products-title-section")}</a></li>
          <li><a href={`${accountPageLink}#my-promotions`}>{t("ecommerce.myaccount.promotion-title-section")}</a></li>
          {BRX_LOCALE === "it_IT" && <li><a href={`${accountPageLink}#my-recipes`}>{t("ecommerce.myaccount.recipes-title")}</a></li>}
          {IS_GIFT_CARD_ACTIVE && <li><a href={`${accountPageLink}#my-giftcard`}>{t("ecommerce.myaccount.giftcard-title")}</a></li>}
        </ul>
        <br /> <br />
        <br /> <br />
        <button className="ec_btn ec_btn_logoutLayer" onClick={logout} >{t("ecommerce.login.logout")}</button>
      </div></div>;

  if (!container)
    return null;

  else {
    return <>

      {Array.from(container_btn).map((button, i) =>
        ReactDOM.createPortal(
          loginButton,
          button
        )
      )
      }
      {Array.from(container).map((layer, i) =>
        ReactDOM.createPortal(
          (userData ? userLoggedLayer : <Login className="easy-login" show="register" isSideBarLogin={true} />),
          layer
        )
      )
      }


    </>
  }

};
